// Component: src/theme/sections/mission.liquid

if (window.inlineImages && window.inlineImages.length > 0) {
  document.querySelectorAll(".with-inline-images").forEach((el) => {
    el.innerHTML = el.innerHTML.replace(/\[(.*?)\]/g, (_, tag) => {
      const deg = Math.floor(Math.random() * (15 - -15) + -15);
      return `<span class="inline-image-wrapper"><img src="${window.inlineImages?.find((i) => i.tag === tag)?.image}" loading="lazy" alt="${tag}" style="transform:rotate(${deg}deg)" /></span>`;
    });
  });
}
